
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import * as React from 'react';
import { SessionProvider, useSession } from 'next-auth/react';
import { Analytics } from '@vercel/analytics/react';
import { ModalProvider } from 'react-modal-hook';
import NextNProgress from 'nextjs-progressbar';
import { SnackbarProvider } from 'notistack';
import type { AppProps } from 'next/app';
import { CacheProvider, EmotionCache } from '@emotion/react';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { SupportProvider } from 'components/hooks/use-support';
import { useUser } from 'components/hooks/state';
import CookieConsent from 'components/atomic/atoms/cookie-consent';
import DefaultSEO from 'components/atomic/atoms/default-seo';
import { createEmotionCache } from 'utils/theme';
import analytics from 'utils/analytics';
import theme from 'utils/theme';
/** Global styles */
import '../styles/globals.css';
interface MyAppProps extends AppProps {
    emotionCache?: EmotionCache;
}
// Client-side cache, shared for the whole session of the user in the browser.
const clientSideEmotionCache = createEmotionCache();
const DevvApp = (props: MyAppProps) => {
    const { emotionCache = clientSideEmotionCache, pageProps, router } = props;
    React.useEffect(() => {
        // TODO: FIX THIS, GETS CALLED TWICE
        analytics.page();
        const handleRouteChange = () => {
            analytics.page();
        };
        router.events.on('routeChangeComplete', handleRouteChange);
        return () => router.events.off('routeChangeComplete', handleRouteChange);
    }, [router.events]);
    return (<SessionProvider session={pageProps.session}>
            <CacheProvider value={emotionCache}>
                <AppWithSession {...props}/>
            </CacheProvider>
        </SessionProvider>);
};
const AppWithSession = (props: AppProps) => {
    const { Component, pageProps } = props;
    const { user } = useUser();
    React.useEffect(() => {
        if (user) {
            analytics.identify(user._id, {
                email: user.email,
                email_verified: user.email_verified,
                first_name: user.first_name,
                subscription_status: user.subscription_status,
                interests: user.interests,
                pre_enrolled_items: [...user.pre_enrolled_tracks, ...user.pre_enrolled_paths],
                enrolled_items: [...user.enrolled_tracks, ...user.enrolled_paths],
            });
        }
    }, [user]);
    return (<ThemeProvider theme={theme}>
            <SnackbarProvider maxSnack={3} anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }} dense>
                <ModalProvider>
                    <SupportProvider>
                        <DefaultSEO />
                        <CookieConsent />
                        <CssBaseline />
                        <NextNProgress color={theme.palette.primary.main}/>
                        <Component {...pageProps}/>
                        <Analytics />
                    </SupportProvider>
                </ModalProvider>
            </SnackbarProvider>
        </ThemeProvider>);
};
const __Next_Translate__Page__18916ceb175__ = DevvApp;

    export default __appWithI18n(__Next_Translate__Page__18916ceb175__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
    });
  